import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./Preloader.css";
import logo from "../../asserts/l.png";
import ll from "../../asserts/l.png";
function Preloader() {
    const { t } = useTranslation();
    const [hide, setHide] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setHide(true), 3500);
        return () => clearTimeout(timer);
    }, []);

    if (hide) return null;

    return (
        <div className="preloader">
            <div className="preloader__container">

                <img src={logo} alt="logo" className="preloader__logo" />
                <img src={ll} alt="logo" className="preloader__logo1" />

                <h1 className="preloader__title">FoxEvents</h1>

                <div className="preloader__bar">
                    <div className="preloader__progress"></div>
                </div>

                <p className="preloader__subtitle">
                    {t('preloader_text')}
                </p>

            </div>
        </div>
    );
}

export default Preloader;